'use client';

import { Stack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useRegistrationStore } from '@/modules/authentication/application';
import type { GraduationStatusStep } from '@/modules/authentication/view-model';

import { GraduationStatusEnum  } from '@packages/contracts';
import { Form } from '@packages/hook-form-wrapper';

export const GraduationStatus = () => {
	const t = useTranslations('authentication.registration.form.graduationStatus');
	const education = useRegistrationStore(state => state.getEducation());
	const { setValue } = useFormContext<GraduationStatusStep>();
	const graduationStatus = useWatch<GraduationStatusStep>({ name: 'graduationStatus' });

	const educationLevel = education?.educationLevel ?? 'GRADUATE_SCHOOL';
	useEffect(() => {
		setValue('graduationDate', undefined);
		setValue('graduationStatus', undefined as never);
	}, [ setValue, educationLevel ]);

	const options = GraduationStatusEnum.options.map(value => ({
		label: t('enum', { graduationStatus: value }),
		value,
	}));

	const enableDateInput = graduationStatus !== GraduationStatusEnum.enum.PENDING;

	return (
		<Stack gap="sm">
			<Form.RadioGroup<GraduationStatusStep> gap={8} name="graduationStatus" options={options} />
			{enableDateInput && <Form.DateInput<GraduationStatusStep> label="Graduation Date" name="graduationDate" />}
		</Stack>
	);
};
